
export default function VisionHero() {
  return (
    <section
      className="relative py-32 bg-cover bg-center bg-no-repeat animated-sky-bg"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/62056cacdaa47b0da9d5a3dcb7d977d3.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-orange-900/60 to-pink-800/40 floating-overlay"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 leading-tight">
            <span className="block text-6xl md:text-8xl mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Reason To Believe
            </span>
            <span className="block text-3xl md:text-5xl text-orange-200">
              理念・ビジョン
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-4xl mx-auto leading-relaxed">
            信頼される理由を常に追求し、お客様・グループ・パートナーとの
            <br className="hidden md:block" />
            持続可能な価値創造を実現します
          </p>
          
          <div className="w-24 h-1 bg-orange-400 mx-auto rounded-full"></div>
        </div>
      </div>
      
      {/* Floating particles effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white/30 rounded-full animate-pulse"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-orange-300/50 rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-3 h-3 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '2s' }}></div>
        <div className="absolute bottom-1/3 right-1/4 w-1 h-1 bg-orange-200/40 rounded-full animate-bounce" style={{ animationDelay: '0.5s' }}></div>
      </div>
    </section>
  );
}
